import get from 'lodash/get';
import extend from 'lodash/extend';
import identityConfig from '../../../config/identity';
import { canUseDOM } from 'exenv';

export default function datalayer(context) {
  const siteConfig = identityConfig;

  if (siteConfig === undefined) {
    return '';
  }

  const {
    postData,
    // tagPageData,
    // categoryPageData,
    // authorPageData,
    // searchPageData,
    // staticPageData,
    // mostCreativePeoplePageData,
    // personPageData,
    // statusCode,
    // ibdPageData,
    // companyPageData,
    // micYearPageData,
    // micSectorPageData,
    // videoPageData,
    // productPageData,
    // playlistAllFeedData,
    type
  } = context;

  // const category = '';
  // const tag = '';

  // Data layer data structure, defaults to homepage value
  // it will be further extended depend on page type
  let dataLayerMapping = {};

  const typeLookup = {
    post() {
      // Apply any attribute modifications hers
      // const environment = 'production';
      // if(document.location.origin.includes('//stage')){
      //   environment = 'stage';
      // }
      // if(document.location.origin.includes('//fastcompany.local')){
      //   environment = 'development';
      // }

      // console.log('POSTDATA', postData);
      // console.log('location',location);
      // console.log('context',context);

      const pageName = postData.title;
      const destinationURL = postData.link;

      let author = '';
      if (postData.author && postData.author.name !== '') {
        author = postData.author.name;
      }

      let primaryCategory = '';
      if (
        postData.categories &&
        postData.categories.length > 0 &&
        postData.categories[0] !== undefined
      ) {
        primaryCategory = postData.categories[0].name;
      }

      let subCategory = '';
      if (
        postData.categories &&
        postData.categories.length > 0 &&
        postData.categories[1] !== undefined
      ) {
        subCategory = postData.categories[1].name;
      } else {
        subCategory = primaryCategory;
      }

      let subSubCategory = '';
      if (
        postData.categories &&
        postData.categories.length > 0 &&
        postData.categories[2] !== undefined
      ) {
        subSubCategory = postData.categories[2].name;
      } else {
        subSubCategory = subCategory;
      }

      let tagString = '';
      tagString = postData.tags.map(tag => tag.name).join(',');

      // let editorName = currentArticleBundle.article.editorname ? currentArticleBundle.article.editorname : '';
      const pubdate = postData.omnitureDate
        ? `${postData.omnitureDate} UTC`
        : '';
      const pageType = postData.type; // For now...

      const urlText = postData.slug.replace(/-/g, ' ');
      // urlText = urlText[urlText.length - 1].replace('.html','').replace(/-/g, ' ');

      let referringURL = '';
      if (canUseDOM) {
        referringURL = document.referrer;
      }

      return extend({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName,
            pageID: `fc${postData.id}`,
            destinationURL: `https://www.inc.com/${destinationURL}`,
            referringURL,
            author,
            editorName: 'FC Editor',
            pubdate,
            daysSincePubdate: Math.round(
              (new Date().getTime() - new Date(`${pubdate}`)) /
                (24 * 60 * 60 * 1000)
            ),
            type: pageType,
            publisher: 'fast company',
            server: 'fc-node',
            urlText,
            editTags: tagString,
            infiniteScrollIndex: 1
          },
          category: {
            primaryCategory: `${primaryCategory}`, // Reserved & recommended
            subCategory1: `${subCategory}`,
            subCategory2: `${subSubCategory}`
          }
        }
      });
    }
  };

  if (typeLookup[type]) {
    dataLayerMapping = typeLookup[type]();
    // dataLayerMapping = {...dataLayerMapping, ...typeLookup[type]()}
  }

  return `<script>
      window.digitalData = {
        page: ${JSON.stringify(get(dataLayerMapping, 'page', ''))}
      };
    </script>
    <script src="//assets.adobedtm.com/launch-ENf6f754d17779412f8d246f49c783f295.min.js" async></script>
  `;
}
